import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";

export const downloadReportListRequest = (callback) => {
    webClient.get('/report')
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};